import { queryOptions } from "@tanstack/react-query";
import { api, expectOk } from "./api";
import { keys } from "./keys";

/** The shell's left rail (working patient list + counts) — one query, shared by every screen. */
export const railQuery = queryOptions({
  queryKey: keys.rail,
  queryFn: async () => expectOk(await api.readModels.rail({}), 200),
  staleTime: 30_000,
});
